module.exports = __webpack_public_path__ + "static/media/Download.f41be9d4.svg";